const ORDERS_TABLE_READY = "orders-table-ready"
const SEARCH_TEXT_STATE = "orders-table-search-text-state"
const ROWS_PER_PAGE_STATE = "orders-table-rows-per-page-state"
const PAGINATION_STATE = "orders-table-pagination-state"

const STATUS_FILTER_STATE = "orders-table-status-filter-state"
const LINE_ITEM_ID_FOR_ACTION = "orders-table-line-item-id-for-action"
const DATE_FILTER_STATE = "orders-table-date-filter-state"

const PUSH_ORDER_VALUE = "orders-table-push-order-value"

const PUSH_ORDER_SUMMARY = "orders-table-push-order-summary"

const ORDER_BULK_PRINT = "orders-table-order_bulk_print"

const initialState = {
    isOrdersTableReady: true,
    orders:{},
    pushOrderDetails:null,
    pushOrderSummary:null,
    lineItemIdForAction:null,

    previousStartDateState: "",
    previousEndDateState: "",

    previousSelectedStatusFilter: null,
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    bulkPrintOrders:{},

}

export default function reducer(state = initialState, action) {
    let duplicateState = null

    switch (action.type) {

        case ORDERS_TABLE_READY:
            return Object.assign({},state,{isOrdersTableReady:action.payload})

        case LINE_ITEM_ID_FOR_ACTION:
            return Object.assign({},state,{lineItemIdForAction:action.payload})

        case DATE_FILTER_STATE:
            duplicateState =Object.assign({},state)
            duplicateState.previousStartDateState=action.payload.start_date
            duplicateState.previousEndDateState=action.payload.end_date
            return Object.assign({},state,duplicateState)

        case STATUS_FILTER_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousSelectedStatusFilter = action.payload
            return Object.assign({},state,duplicateState)

        case SEARCH_TEXT_STATE:
            return Object.assign({},state,{previousSearchText:action.payload})

        case ROWS_PER_PAGE_STATE:
            return Object.assign({},state,{previousRowsPerPageValue:action.payload})
        
        case PAGINATION_STATE:
            duplicateState = Object.assign({}, state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case PUSH_ORDER_VALUE:
            return Object.assign({}, state, { pushOrderDetails: action.payload })
        
        case PUSH_ORDER_SUMMARY:
            return Object.assign({}, state, { pushOrderSummary: action.payload })

        case ORDER_BULK_PRINT:
            return Object.assign({}, state, { bulkPrintOrders: action.payload })

        default:
            return state
    }
}

export function orderTableReady(data){
    return{
        type: ORDERS_TABLE_READY,
        payload: data
    }
}

export function lineItemIdForAction(id) {
    return {
        type: lineItemIdForAction,
        payload: id
    }
}

export function statusFilterSelected(status){
    return{
        type:STATUS_FILTER_STATE,
        payload:status
    }
}

export function dateFilterSelected(date){
    return{
        type:DATE_FILTER_STATE,
        payload:date
    }
}


export function selectedSearchTextUpdate(text) {
    return {
        type: SEARCH_TEXT_STATE,
        payload: text
    }
}

export function rowsPerPageUpdate(rowsPerPage) {
    return {
        type: ROWS_PER_PAGE_STATE,
        payload: rowsPerPage
    }
}

export function paginationUpdate(pageNo) {
    return {
        type: PAGINATION_STATE,
        payload: pageNo
    }
}

export function pushOrderUpdate(value){
    return{
        type: PUSH_ORDER_VALUE,
        payload:value
    }
}

export function pushOrderSummaryUpdate(value){
    return{
        type: PUSH_ORDER_SUMMARY,
        payload:value
    }
}

export function bulkPrintOrders(value){
    return{
        type: ORDER_BULK_PRINT,
        payload:value
    }
}


// WEBPACK FOOTER //
// ./src/modules/OrdersTable/redux/orders.js